import { LAYOUT } from '../constants'

/**
 * @type {import('vue-router').RouteConfig[]}
 */
export default [
  {
    path: '/alumniProfile',
    component: LAYOUT,
    redirect: '/alumniProfile/domestic',
    meta: { title: '校友风采', showNavPanel: true },
    children: [
      {
        path: 'domestic',
        name: '国内优秀校友',
        component: () => import('@/views/alumniProfile/domestic.vue'),
        meta: { title: '国内优秀校友' },
      },
      // {
      //   path: 'overseas',
      //   name: '国外优秀校友',
      //   component: () => import('@/views/alumniProfile/overseas.vue'),
      //   meta: { title: '国外优秀校友' },
      // },
      // {
      //   path: 'outstanding',
      //   name: '卓越校友',
      //   component: () => import('@/views/alumniProfile/outstanding.vue'),
      //   meta: { title: '卓越校友' },
      // },
      // {
      //   path: 'supervisor',
      //   name: '就业创业导师',
      //   component: () => import('@/views/alumniProfile/supervisor.vue'),
      //   meta: { title: '就业创业导师' },
      // },
      // {
      //   path: 'outstandingContribution',
      //   name: '突出贡献校友',
      //   component: () => import('@/views/alumniProfile/outstandingContribution.vue'),
      //   meta: { title: '突出贡献校友' },
      // },
      {
        path: 'mediaReports',
        name: '媒体报道',
        component: () => import('@/views/alumniProfile/mediaReports.vue'),
        meta: { title: '媒体报道' },
      },
      {
        path: 'photo',
        name: '照片',
        component: () => import('@/views/alumniProfile/photo.vue'),
        meta: { title: '照片' },
      },
      {
        path: 'video',
        name: '视频',
        component: () => import('@/views/alumniProfile/video.vue'),
        meta: { title: '视频' },
      },
    ],
  },
]
